import { createAction } from 'redux-actions'
import {
  SEARCH_VENDORS,
  SEARCH_VENDORS_FAILED,
  SEARCH_VENDORS_SUCCEEDED,
  CREATE_VENDOR,
  CREATE_VENDOR_FAILED,
  CREATE_VENDOR_SUCCEEDED,
  CLEAR_CREATED_VENDOR,
} from 'Redux/Types/SearchVendorTypes'

export const searchVendors = createAction(SEARCH_VENDORS)
export const searchVendorsFailed = createAction(SEARCH_VENDORS_FAILED)
export const searchVendorsSucceeded = createAction(SEARCH_VENDORS_SUCCEEDED)

export const createVendor = createAction(CREATE_VENDOR)
export const clearCreatedVendor = createAction(CLEAR_CREATED_VENDOR)
export const createVendorFailed = createAction(CREATE_VENDOR_FAILED)
export const createVendorSucceeded = createAction(CREATE_VENDOR_SUCCEEDED)
